export default function PHP_tempnam() {
  return (
    <div>
      <h1>PHP_tempnam</h1>
    </div>
  );
}
